export const validate = (value, minLength, maxLength) =>
  (value.length >= minLength && value.length <= maxLength);

export const validateSelect = (value, minLength, maxLength) => {
  if (value === undefined) {
    return minLength < 1;
  }

  const subject = Array.isArray(value) ? value : [value];

  return validate(subject, minLength, maxLength);
};

export const validateText = (value, minLength, maxLength) => {
  if (value === undefined) {
    return minLength < 1;
  }

  return validate(value, minLength, maxLength);
};

export const validateFormField = (value, { minLength, maxLength, type }) => {
  switch (type) {
    case 'text_select':
    case 'image_select':
      return validateSelect(value, minLength, maxLength);
    case 'text':
      return validateText(value, minLength, maxLength);
    default:
      return true;
  }
};



// WEBPACK FOOTER //
// ./src/ConfigurableProduct/FormFieldValidator.js